import { useQuery } from '@tanstack/react-query';
import { default as addressService } from "../services/address";

export const useProvincies = (stateCode: string) => {
  const isReady = !!stateCode;

  return useQuery({
    queryKey: ['provincies', stateCode],
    queryFn: () => addressService.fetchProvincies(stateCode),
    enabled: isReady,
    staleTime: 1000 * 60 * 30
  })
  
}